@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.seller-provider-list {
  background: @rate-viewer-seller-provider-list--background-color;
  padding: 10px;
  min-height: 100%;
}

.provider-section {
  &:not(:last-child) {
    margin-bottom: @space-16;
  }
}

.section-header {
  font-weight: 400;
  color: var(--grey-600);
  margin-bottom: @space-8;
}

.seller-provider-list-item {
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
